export const exportToPdfDisseminationLessonService =
  (fetch) => async (filters) => {
    try {
      const searchParams = new URLSearchParams(filters).toString();
      const response = await fetch({
        url: `/api/v1/siniestros-viales/divulgacion-lecciones/export/pdf?${searchParams}`,
        responseType: "blob",
      });

      const blob = new Blob([response], {
        type: "application/pdf",
      });
      return blob;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
